<nb-card class="model4-full">
    <nb-card-header>
        <div>
            Edit Introduction
        </div>
        <button (click)="close()" size="small" nbButton ghost status="basic"><nb-icon icon="close-outline"></nb-icon></button>
    </nb-card-header>
    <nb-card-body>
      <textarea nbInput fullWidth [(ngModel)]="text" rows="100" placeholder="Please enter your Introduction..."></textarea>
          <div class="row pt-4">
            <div class="col-xxl-12 col-xl-12 col-md-12 col-sm-12 align">
              <button nbButton size="small" status="danger" (click)="editIntroduction()">Save Introduction</button>
            </div>
          </div>
    </nb-card-body>
</nb-card>
